import { useNavigate } from "react-router-dom";
import CustomisedButton from "../../components/button/button";
import EmptyStyle from "../../components/emptyStyles/emptyStyle";
import { Typography } from "@mui/material";
import { useMutation } from "react-query";
import { GetSupportInfo } from "../../services/system/system.service";
import MaintenanceIcon from "../../components/icons/MaintenanceIcon";

export default function ExceptionPage() {
    const navigate = useNavigate();
    const { mutateAsync } = useMutation(GetSupportInfo, {
        onSuccess: (data) => {
            if (data) {
                navigate('/')
            }
        }
    })
    const handleManitance = () => {
        mutateAsync()

    }
    return (
        <div className="w-full h-full flex flex-col justify-center items-center gap-20 p-20">
            <div>
                <EmptyStyle text={'متاسفانه مشکلی رخ داده است'} icon={<MaintenanceIcon className="text-[var(--primary-text-color)]" />} emphasisedWords={[]} emphasisedWordsColor="" >
                    <Typography style={{ fontSize: ".9rem", color: "var(--primary-text-color)" }}>لطفا دقایقی دیگر مراجعه فرمایید.</Typography>
                </EmptyStyle>
            </div>
            <div className="w-full">
                <CustomisedButton title="تلاش مجدد" disable={false} onClick={handleManitance} type="button" />
            </div>
        </div>
    )
}
